import { MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Watch, Component, Mixins } from 'vue-property-decorator';

/**
 * Component to let the user select a boolean value. It is displayed as a
 * radio.
 * @remarks If using v-wmodel, always add the modifier .lazy
 */
var RadioComponent = /** @class */ (function (_super) {
    __extends(RadioComponent, _super);
    function RadioComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RadioComponent.prototype.onChange = function () {
        return this.value;
    };
    RadioComponent.prototype.onFocusChange = function () {
        if (this.focused) {
            this.$refs.input.focus();
        }
    };
    RadioComponent.prototype.mounted = function () {
        var _this = this;
        this.$nextTick(function () {
            // Once element has been upgraded to a web component (next tick after mounted).
            _this.register();
        });
    };
    RadioComponent.prototype.register = function () {
        return this.$el.getRootNode().host;
    };
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], RadioComponent.prototype, "value", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], RadioComponent.prototype, "checked", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], RadioComponent.prototype, "bold", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], RadioComponent.prototype, "block", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], RadioComponent.prototype, "floating", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], RadioComponent.prototype, "focused", void 0);
    __decorate([
        Emit('change'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RadioComponent.prototype, "onChange", null);
    __decorate([
        Watch('focused', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RadioComponent.prototype, "onFocusChange", null);
    __decorate([
        Emit('register'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], RadioComponent.prototype, "register", null);
    RadioComponent = __decorate([
        Component({
            name: 'ui-radio',
        })
    ], RadioComponent);
    return RadioComponent;
}(Mixins(MagicConfigMixin)));

export default RadioComponent;
